import { SET_CART_PRODUCT_IDS, ADD_CART_PRODUCT_ID } from 'store/actions'

const cartProductIdsReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_CART_PRODUCT_ID:
      return [...state, action.productId]
    case SET_CART_PRODUCT_IDS:
      return [...action.productIds]
    default:
      return state
  }
}

export default cartProductIdsReducer
